// A "Raise SAFed test" control that opens the raise flow with the lift already chosen (Session BDC). It sits in the lift page header
// and beside each lift in the Compliance and SAFed tests lists, so the office never has to hunt for the lift's SAFed panel first.
import { useState } from "react";
import { Gauge } from "lucide-react";
import { Button } from "../../components/Button";
import { RaiseSafedTestModal } from "./RaiseSafedTestModal";

export function RaiseSafedButton({ assetId, onRaised, compact }: { assetId: string; onRaised?: () => void; compact?: boolean }) {
  const [open, setOpen] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);
  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => setOpen(true)} icon={compact ? undefined : <Gauge aria-hidden size={14} />}>
        Raise SAFed test
      </Button>
      {notice && <span role="status" className="text-xs text-ele-green">{notice}</span>}
      {open && (
        <RaiseSafedTestModal
          assetId={assetId}
          onClose={() => setOpen(false)}
          onRaised={() => {
            setOpen(false);
            setNotice("SAFed test job raised.");
            onRaised?.();
          }}
        />
      )}
    </>
  );
}
